const DISMISS_PREFIX = "notice_dismissed_";
const DAY_MS = 24 * 60 * 60 * 1000;

export const isNoticeDismissed = (noticeId, now = Date.now()) => {
  try {
    const raw = localStorage.getItem(DISMISS_PREFIX + noticeId);
    if (!raw) return false;
    const saved = JSON.parse(raw);
    // Older versions stored the click timestamp for a one-day dismissal.
    const until = typeof saved === "number" ? saved + DAY_MS : saved?.until;
    return Number.isFinite(until) && now < until;
  } catch {
    return false;
  }
};

export const dismissNotice = (noticeId, days, now = Date.now()) => {
  if (days !== 1 && days !== 7) return;
  try {
    localStorage.setItem(DISMISS_PREFIX + noticeId, JSON.stringify({ until: now + days * DAY_MS }));
  } catch {
    // The provider still closes this notice when browser storage is unavailable.
  }
};

export const noticeDismissDays = (notice) => notice?.dismissDays === 7 ? 7 : 1;
